import React from 'react';
import styles from './BottomLinks.module.scss';

export default function BottomLinks({ url, label }) {
  return (
    <a href={`${url}`} className={styles.nav_link_bottom} title="">
      <span className={`d-inline ${styles.label}`}>{label}</span>
    </a>
  );
}
